import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.537 3.123H10.463c-1.604 0-2.406 0-3.05.398-.645.399-1.003 1.116-1.72 2.55L3.82 10.802c-.432 1.093-.81 2.381-.083 3.304a2.667 2.667 0 0 0 4.762-1.65 2.667 2.667 0 0 0 5.333 0 2.667 2.667 0 0 0 5.333 0 2.667 2.667 0 0 0 5.334 0 2.667 2.667 0 0 0 4.762 1.65c.727-.923.349-2.21-.083-3.304l-1.872-4.73c-.717-1.435-1.076-2.152-1.72-2.55-.645-.399-1.446-.399-3.05-.399M13.164 28.79v-3.668c0-1.246 0-1.869.268-2.333.175-.304.428-.556.732-.732.464-.268 1.087-.268 2.333-.268s1.87 0 2.334.268a2 2 0 0 1 .732.732c.268.464.268 1.087.268 2.333v3.667z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.836 15.123a2.667 2.667 0 0 0 2.666-2.667 2.667 2.667 0 0 0 5.334 0 2.667 2.667 0 0 0 5.333 0 2.667 2.667 0 0 0 5.333 0 2.667 2.667 0 0 0 2.667 2.667v13.666h-7.333v-3.666c0-1.246 0-1.87-.268-2.334a2 2 0 0 0-.732-.732c-.464-.268-1.087-.268-2.333-.268s-1.87 0-2.334.268a2 2 0 0 0-.732.732c-.268.464-.268 1.088-.268 2.334v3.666H5.836z",
      "clip-rule": "evenodd",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.83 28.79H3.165a1 1 0 1 0 0 2h26.667a1 1 0 1 0 0-2h-10"
    }, null, -1)
  ])))
}
export default { render: render }